module.exports = __webpack_public_path__ + "img/rightBottom.f62540d7.png";